<template>
  <div class="cart-card">
    <div class="cart-head">
      <div class="check-box" :class="{ 'cur' : allChecked }" @click="selectAll"></div>
      <div style="cursor: pointer;" @click="$router.push(info.vemtype === 1 ? `/machine/index?vemId=${info.vemId}` : `/coffee/index?vemId=${info.vemId}`)">
        <span>{{ info.vemname }}</span>
        <span style="padding-left: 20px;color: #999; font-size: 14px;">{{ lang.vemid }}：{{ info.vemId }}</span>
      </div>
    </div>
    <div class="cart-list" v-for="(item, index) in carts" :key="index">
      <div class="goods-info">
        <div class="check-box" :class="{ 'cur': item.checked }" @click="selectGoods(index)"></div>
        <el-image :src="item.productimg" lazy @click="selectGoods(index)"></el-image>
        <div @click.stop="$router.push('/goods/info/'+item.productno)" class="info">
          <div class="name">{{ item.productname }}</div>
          <div class="desc">{{ item.briefName }}</div>
        </div>
      </div>
      <div class="goods-price">
        <div
          v-if="item.productpricedoor > 0"
          class="o-price"
        >{{ lang.original_price }}{{ unit }}&nbsp;{{ item.productpricedoor.toFixed(2) }}</div>
        <div class="d-price">
          {{ unit }}
          <span>{{ item.productprice.toFixed(2) }}</span>
        </div>
      </div>
      <div class="goods-num">
        <el-input-number
          v-model="item.productnum"
          :min="1"
          :max="item.stock"
          @change="(value) => handleNumber(value, item)"
        ></el-input-number>
      </div>
      <div class="goods-amount">
        {{ unit }}
        <span>{{ (item.productprice * item.productnum).toFixed(2) }}</span>
      </div>
      <div class="action">
        <svg-icon iconClass="delete" @click="handleDelCart(item.id)" />
        <svg-icon
          style="margin-left: 10px"
          @click="handleCollect(item.productno, index)"
          :iconClass="item.isproductCollection ? 'collect_cur' : 'icon_collect'"
        />
      </div>
    </div>
    <div class="cart-footer">
      <div class="right">
        <div class="amount">
          <div class="name">{{ lang.total }}：</div>
          {{ unit }}<span>{{ totalPrice }}</span>
        </div>
        <div @click="handleSettlement" v-if="checkNum > 0" class="btn cur">{{ lang.settle }}({{ checkNum }})</div>
        <div v-else class="btn">{{ lang.settle }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { addproductColl } from '@/api/product'
import { addcart, delcart } from '@/api/cart.js'
import { getbuycartdetail } from '@/api/order'
export default {
  props: {
    info: {
      type: Object,
      default: undefined
    }
  },
  watch: {
    info: {
      handler(e) {
        this.carts = e.childitems.map(item => {
          return {
            ...item,
            checked: false
          }
        })
      },
      immediate: true,
      deep: true
    }
  },
  data() {
    return {
      num: 1,
      carts: []
    }
  },
  computed: {
    lang() {
      return this.$t('cart')
    },
    ...mapGetters(['isLogin', 'location', 'unit']),
    checkNum() {
      let i = 0
      this.carts.forEach((item) => {
        if (item.checked) i++
      })
      return i
    },
    totalPrice() {
      let totalPrice = 0
      this.carts.forEach((item) => {
        if (item.checked) {
          totalPrice += item.productnum * item.productprice
        }
      })
      return parseFloat(totalPrice).toFixed(2)
    },
    allChecked: {
      get() {
        return this.checkNum === this.carts.length
      },
      set() {
        let isAllSelected = this.carts.every((item) => {
          return item.checked
        })
        isAllSelected ? true : false
      }
    },
    cartIds() {
      let ids = []
      this.carts.forEach((item) => {
        if (item.checked) {
          ids.push(item.id)
        }
      })
      return ids
    }
  },
  methods: {
    handleSettlement() {
      if (this.cartIds.length === 0) return
      getbuycartdetail({
        cartids: this.cartIds.join(','),
        ...this.location
      }).then((res) => {
        if (res.code === 1) {
          this.$router.push({
            path: '/order/confirm',
            query: {
              ids: this.cartIds.join(',')
            }
          })
        }
      })
    },
    // 收藏
    async handleCollect(id, index) {
      addproductColl({
        productno: id
      }).then((res) => {
        if (res.code === 1) {
          this.carts[index].isproductCollection =
            this.carts[index].isproductCollection === 1 ? 0 : 1
        }
      })
    },
    handleEmpty() {
      const ids = this.carts.map((item) => {
        return item.id
      })
      this.$confirm(this.lang.modal_text1, this.lang.tips, {
        confirmButtonText: this.lang.confirm_text,
        cancelButtonText: this.lang.cancel_text,
        type: 'warning'
      }).then(() => {
        delcart({ cartid: ids.join(',') }).then((res) => {
          if (res.code === 1) {
            this.$message.success(res.msg)
            this.$parent.init()
          }
        })
      })
    },
    handleDelCart(id) {
      if (id === 0 && this.cartIds.length === 0) {
        this.$message.error(this.lang.select_tips)
        return
      }
      this.$confirm(this.lang.modal_text2, this.lang.tips, {
        confirmButtonText: this.lang.confirm_text,
        cancelButtonText: this.lang.cancel_text,
        type: 'warning'
      }).then(() => {
        delcart({ cartid: id === 0 ? this.cartIds.join(',') : id }).then(
          (res) => {
            if (res.code === 1) {
              this.$message.success(res.msg)
              this.$parent.init()
            }
          }
        )
      })
    },
    selectAll() {
      if (this.allChecked) {
        this.carts.forEach((item) => {
          item.checked = false
        })
        this.allChecked = false
      } else {
        this.carts.forEach((item) => {
          item.checked = true
        })
        this.allChecked = true
      }
    },
    selectGoods(index) {
      this.carts[index].checked = !this.carts[index].checked
    },
    handleNumber(value, item) {
      addcart({
        productno: item.productno,
        productnum: value,
        vemId: item.vemId,
        type: 1
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.cart-card {
  margin-bottom: 20px;
  border-radius: 12px;
  background: #ffffff;
}
.cart-head {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ccc;
  height: 50px;
  color: #333;
  font-size: 15px;
  font-weight: 500;
  .check-box {
    margin: 0 10px;
  }
}
.cart-list {
  padding: 15px 0;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #eee;
  .goods-info {
    cursor: pointer;
    display: flex;
    width: 570px;
    .check-box {
      margin: 33px 10px 0;
    }
    .el-image {
      width: 80px;
      height: 80px;
      margin-right: 15px;
    }
    .name {
      font-size: 14px;
      color: #000;
      padding-bottom: 6px;
    }
    .desc {
      color: #666;
      font-size: 12px;
    }
  }
  .goods-price,
  .goods-num {
    width: 165px;
    /deep/ .el-input-number__increase,
    /deep/ .el-input-number__decrease {
      top: 0;
      background: #fff;
      border: 0;
      width: 22px;
      height: 22px;
      line-height: 22px;
      border-radius: 6px;
      font-size: 14px;
      border: 1px solid #ec9221;
      color: #ffffff;
      i {
        color: #ec9221;
      }
    }
    /deep/ .el-input-number--small {
      width: 90px;
      line-height: 24px;
    }
    /deep/ .el-input-number {
      .el-input {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .el-input__inner {
        padding: 0;
        width: 50px;
        height: 24px;
        line-height: 24px;
        border: 1px solid #fff;
        color: #000;
        font-size: 14px;
      }
    }
  }
  .goods-price {
    .o-price {
      font-size: 12px;
      color: #000;
      padding-bottom: 4px;
      text-decoration: line-through;
    }
    .d-price {
      color: #ff0000;
      font-size: 12px;
      span {
        padding-left: 5px;
        font-size: 16px;
        font-weight: 700;
      }
    }
  }
  .goods-amount {
    width: 162px;
    padding-left: 10px;
    color: #ff0000;
    font-size: 12px;
    span {
      padding-left: 5px;
      font-size: 16px;
      font-weight: 700;
    }
  }
  .action {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-left: 15px;
  }
}

.cart-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 60px;
  padding: 0 10px;
  .right {
    display: flex;
    align-items: center;
  }
  .amount {
    display: flex;
    align-items: center;
    padding-right: 15px;
    .name {
      color: #000000;
      font-size: 14px;
    }
    color: #ff0000;
    font-size: 12px;
    span {
      font-size: 16px;
      font-weight: bold;
      padding-left: 6px;
    }
  }
  .btn {
    cursor: pointer;
    text-align: center;
    width: 100px;
    height: 38px;
    line-height: 38px;
    background: #aaaaaa;
    border-radius: 8px;
    color: #fff;
    font-size: 16px;
    &.cur {
      background: #ec9221;
    }
  }
}

.check-box {
  width: 16px;
  height: 16px;
  border: 1px solid #ec9221;
  border-radius: 50%;
  margin-right: 5px;
  &.cur {
    background: #ec9221;
  }
}

</style>